<template>
  <div class="info-section">
    <h5>Pressure Changes</h5>
    <div class="info-grid">
      <div class="info-item">
        <span class="label">On Change:</span>
        <span class="value">{{ pressureChange.onChange }} Pa</span>
      </div>
      <div class="info-item">
        <span class="label">Off Change:</span>
        <span class="value">{{ pressureChange.offChange }} Pa</span>
      </div>
      <div class="info-item">
        <span class="label">Before On:</span>
        <span class="value">{{ pressureChange.beforeOn }} Pa</span>
      </div>
      <div class="info-item">
        <span class="label">After Off:</span>
        <span class="value">{{ pressureChange.afterOff }} Pa</span>
      </div>
      <div class="info-item">
        <span class="label">Valid:</span>
        <span class="value status-badge" :class="{ 'valid': pressureChange.valid, 'invalid': !pressureChange.valid }">
          {{ pressureChange.valid ? 'Yes' : 'No' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CyclePressureSection',
  props: {
    pressureChange: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.info-section {
  margin-bottom: 24px;
  background: rgb(24, 32, 64);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid rgb(58, 74, 107);

  h5 {
    margin: 0 0 16px 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 2px solid #4a9eff;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '🏔️';
      font-size: 14px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background: rgb(32, 40, 80);
      border-radius: 8px;
      border: 1px solid rgb(58, 74, 107);
      min-height: 52px;
      word-break: break-word;
      transition: all 0.2s ease;

      &:hover {
        background: rgb(42, 58, 107);
        border-color: #4a9eff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      }

      .label {
        font-weight: 600;
        color: #ffffff;
        font-size: 13px;
        flex-shrink: 0;
        margin-right: 16px;
        min-width: 140px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .value {
        font-weight: 700;
        color: #ffffff;
        font-size: 14px;
        text-align: right;
        word-break: break-word;
        overflow-wrap: break-word;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;

        &.status-badge {
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border: 2px solid transparent;

          &.valid {
            background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%);
            color: #2e7d32;
            border-color: #2e7d32;
          }

          &.invalid {
            background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
            color: #d32f2f;
            border-color: #d32f2f;
          }
        }
      }
    }
  }
}
</style>
